import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Missing Authorization ", -1)
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", null, [
        _createTextVNode(" You have not the right to access this site. Please request access it via "),
        _createElementVNode("a", { href: _ctx.link }, _toDisplayString(_ctx.link), 9, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}